"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = void 0;
const Name = exports.Name = 'order-placed';
//# sourceMappingURL=index.js.map